/* eslint-disable react-hooks/exhaustive-deps */
import { get, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getCommunity } from "../../apis/community/community";
import { getCommunityPostList, deleteCommunityPost } from "../../apis/community/communityBoard";
import Filters from "../../components/Filters";
import PageHeader from "../../components/PageHeader";
import { ControlTable } from "../../components/Table";
import { COMMUNITY_BOARD_SEARCH_OPTIONS } from "../../constants/COMMUNITY";
import useForm from "../../hooks/useForm";
import { getParams } from "../../utils/params";
import { permissionCheck } from "../../utils/permission";
import systemAlert from "../../utils/systemAlert";
import DetailCommunityPost from "./DetailCommunityPost";
import CommentIcon from "../../assets/images/icon/comment-icon.svg";
import Icon from "../../components/Icon";


const Community = () => {
  const { communityIdx } = useParams();
  const history = useHistory();
  const { permissions, employee } = useSelector((store) => ({
    permissions: store.Profile.permissions,
    employee: store.Profile.employee,
  }));

  const [mode, setMode] = useState('create');

  const [community, setCommunity] = useState(null);
  const [targetPermission, setTargetPermission] = useState(null);
  const [notices, setNotices] = useState([]);
  const [fields] = useState([
    {
      //key: 'index',
      key: 'count',
      width: '100px'
    },
    {
      title: "제목",
      className: 'text-align-left',
      key: "title",
      onValue: (value) => {
        return value === 'null' || isEmpty(value) ? <span className="color-red-80">삭제된 게시글 입니다.</span> : value;
      }
    },
    { title: "작성일시", key: "createdTime", type: 'datetime' },
    {
      title: "작성자",
      key: "writerEmployeeIdx",
      type: 'profile'
    },
    {
      title: '',
      key: 'comments',
      onValue: (value) => {
        return (
          !isEmpty(value) ? (
            <>
              <Icon src={CommentIcon} />
              <span className="ml-4 font-bold">{value.count}</span>
            </>
          ) : (<></>)
        );
      }
    },
    {
      title: "조회수",
      key: "viewCount",
      type: 'comma'
    },
  ]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedCommunityPost, setSelectedCommunityPost] = useState(null);
  const [filters] = useState([
    {
      title: "분류",
      type: "select",
      key: "searchType",
      options: {
        list: COMMUNITY_BOARD_SEARCH_OPTIONS,
      },
    },
    {
      title: "키워드 검색",
      type: "input",
      key: "searchText",
      placeholder: "검색어 입력",
    },
    {
      title: '작성자',
      type: 'searchEmployees',
      key: 'writerEmployee',
    },
  ]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    reSubmit,
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      searchType: 'title',
      searchText: '',
      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'COMMUNITY');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "COMMUNITY");
      }
    }
  }, [permissions]);

  useEffect(() => {
    if (communityIdx && targetPermission) {
      getCommunity(communityIdx)
        .then((data) => {
          setCommunity(data.data);
          submit(form);
          setSubmit(submit);
        })
        .catch((error) => {
          if (get(error, "request.status")) {
            systemAlert('해당 게시판 권한이 없습니다.', {
              buttons: [
                {
                  label: '확인',
                  onClick: () => {
                    history.push('/community');
                  }
                }
              ]
            });

          }
        });
    }
  }, [communityIdx, targetPermission]);

  const submit = ({ writerEmployee, ..._params }) => {

    const params = {
      ..._params,
      ...!isEmpty(writerEmployee) && { writerEmployeeIdx: writerEmployee.map(e => e.idx) },
    };
    setTotal(0);
    setList([]);
    getCommunityPostList(communityIdx, getParams(params))
      .then((res) => {
        const { total, metadata, notices, posts, comment } = res.data;
        setTotal(total);
        console.log(posts.map((post, index) => ({
          ...post,
          //title: `${!!notices.find(n => n.idx === post.idx) ? '[공지] ' : ''}${post.title}`,
          count: total - metadata.offset - index,
          comments: comment.listByPost.find(c => c.postIdx === post.idx) || {}
        })));
        setList(posts.map((post, index) => ({
          ...post,
          //title: `${!!notices.find(n => n.idx === post.idx) ? '[공지] ' : ''}${post.title}`,
          count: total - metadata.offset - index,
          comments: comment.listByPost.find(c => c.postIdx === post.idx) || {}
        })));
        setNotices(notices.map((post) => ({
          ...post,
          comments: comment.listByPost.find(c => c.postIdx === post.idx) || {}
        })));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const headerButtons = [
    {
      label: "글쓰기",
      action: () => {
        setMode("create");
        setDetailOpen(true);
      },
    },
  ];
  const openDetail = (data, e) => {
    if (!data.deletedTime) {
      setMode("view");
      setDetailOpen(true);
      setSelectedCommunityPost(data);
    }
  };

  const rowBtnConfig = {
    rowButtons: [
      {
        isHide: (data) => {
          return data.writerEmployeeIdx !== employee.employeeIdx;
        },
        label: "삭제",
        type: "delete",
        action: (data) => {
          systemAlert(`"${data.title}" 삭제하시겠습니까?`, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  setIsLoading(true);
                  deleteCommunityPost(community.idx, data.idx)
                    .then(() => {
                      reSubmit();
                      systemAlert('삭제 되었습니다.');
                    });
                }
              }
            ]
          });
        },
      },
      {
        isHide: (data) => {
          return data.writerEmployeeIdx !== employee.employeeIdx;
        },
        label: "수정",
        type: "edit",
        action: (data) => {
          setMode('modify');
          setDetailOpen(true);
          setSelectedCommunityPost(data);
        },
      },
    ],
  };


  return (
    !isEmpty(targetPermission) && community && <>
      <PageHeader title={`커뮤니티 - ${community.title}`} buttons={headerButtons} />
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        fields={fields}
        rowBtn={rowBtnConfig}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        notices={notices}
        limit={limit}
        setLimit={setLimit}
        onSelect={openDetail}
        submit={handleSubmit}
      />
      <DetailCommunityPost
        community={community}
        permission={targetPermission}
        post={selectedCommunityPost}
        orgMode={mode}
        setPost={setSelectedCommunityPost}
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={reSubmit}
      />
    </>
  );
};

export default Community;
